export const LOCALES = {
    ENGLISH: 'en-ca',
    FRENCH: 'fr-ca',
};